import API from "./api";

export const GetTrainingVideo = (baseUrl: string) =>
  API.get(`${baseUrl}api/Training/getTrainingVideos`);

export const GetGeneratedVideoUrl = (baseUrl: string, url: string) =>
  API.get(`${baseUrl}api/Training/getGeneratedVideoUrl?url=${url}`);

export const DeleteTrainingVideo = (baseUrl: string, videoId: number) => 
  API.delete(`${baseUrl}api/Training?videoId=${videoId}`);

export const PostTrainingVideo = (baseUrl: string, payload: FormData) =>
  API.postApi(`${baseUrl}api/Training/uploadTrainingVideo`, payload);

export const PutTrainingVideo = (baseUrl: string, payload: FormData) =>
  API.putApi(`${baseUrl}api/Training/updateTrainingVideo`, payload);